// extracted by mini-css-extract-plugin
export var active = "_e1-c";
export var compactArrow = "_e1-5";
export var container = "_e1-0";
export var dot = "_e1-b";
export var dotContainer = "_e1-a";
export var hoverArrowButton = "_e1-7";
export var hoverArrowContainer = "_e1-6";
export var leftHoverArrowContainer = "_e1-8 _e1-6";
export var rightHoverArrowContainer = "_e1-9 _e1-6";
export var slide = "_e1-4";
export var sliderContainer = "_e1-1";
export var sliderContainerVisibleOverflow = "_e1-2";
export var sliderOverflow = "_e1-3";
export var vignetteBoth = "_e1-f";
export var vignetteLeft = "_e1-e";
export var vignetteRight = "_e1-d";